import { useMemo } from 'react';
import { TestScoreCell } from '../../cells';
import { CandidateCol, CellParams } from '.';
import { PercentileScoreDTO } from '@/Models/CandidateOverview';
import { TestTypes } from '@/Models/Configuration';
import UIStrings from '@/Utils/UIStrings';

const useTestColumns = (includedTests: TestTypes[]) => {
    return useMemo<CandidateCol[]>(() => {
        const getTestColumn = (test: TestTypes): [string, CandidateCol['accessorKey']] => {
            switch (test) {
                case TestTypes.Aptitude:
                    return [UIStrings.Aptitude, 'aptitudePercentileScore'];
                case TestTypes.EmotionalIntelligence:
                    return [UIStrings.EmotionalIntelligence, 'emotionalIntelligencePercentileScore'];
                case TestTypes.Personality:
                    return [UIStrings.Personality, 'personalityPercentileScore'];
                case TestTypes.Skills:
                    return [UIStrings.Skills, 'skillsPercentileScore'];
                default:
                    throw new Error('invalid test type');
            }
        };

        return includedTests.map((test): CandidateCol => {
            const [header, accessorKey] = getTestColumn(test);

            return {
                accessorKey,
                header,
                Cell: ({ cell }: CellParams) => <TestScoreCell scoring={cell.getValue<PercentileScoreDTO>()} />,
                size: 166,
            };
        });
    }, [includedTests]);
};

export default useTestColumns;
